 document.addEventListener('click', function (e) {
    const button = e.target.closest('.js-tag-nav-toggle');
    if (!button) return;

    const expanded = button.getAttribute('aria-expanded') === 'true';
    const targetId = button.getAttribute('aria-controls');
    const target = document.getElementById(targetId);

    button.setAttribute('aria-expanded', String(!expanded));
    if (target) {
      target.hidden = expanded; // 開いていれば閉じる、閉じていれば開く
    }
  });
  (() => {
    'use strict';

    // ============================================================
    // 現在のURLから絞り込み中のタグ一覧を取得する
    // ============================================================
    const getCurrentTagsFromUrl = () => {
      let tags = [];

      const path = decodeURIComponent(window.location.pathname);
      const basePath = '/collections/';
      if (path.indexOf(basePath) !== -1) {
        const after = path.split(basePath)[1] || '';
        const segments = after.split('/').filter(Boolean);
        if (segments.length > 1) {
          tags = segments[1].split('+').filter(Boolean);
        }
      }

      if (!tags.length) {
        const params = new URLSearchParams(window.location.search);
        tags = params.getAll('tag').filter(Boolean);
      }

      return tags;
    };

    // ============================================================
    // 各パネル内の data-filter-tag 要素に active クラスを後付けする
    // ============================================================
    const applyActiveStates = (currentTags) => {
      if (!currentTags.length) return;

      const links = document.querySelectorAll('[data-filter-tag]');
      links.forEach((link) => {
        const tag = link.getAttribute('data-filter-tag');
        if (currentTags.indexOf(tag) !== -1) {
          link.classList.add('active');
          if (link.hasAttribute('data-filter')) {
            link.setAttribute('data-filter', 'true');
          }
        }
      });
    };

    // ============================================================
    // パネル本体(filter-panel-content)にも active を後付け
    // ============================================================
    const syncPanels = () => {
      const panels = document.querySelectorAll('[data-panel]');
      panels.forEach((panel) => {
        if (panel.querySelector('.active[data-filter-tag]')) {
          panel.classList.add('active');
        }
      });
    };

    // ============================================================
    // タブボタンに active クラス + 選択中タイトルを反映する
    //   ・表示テキストは button 内の [data-text-label] だけを書き換える
    //   ・デフォルトラベルは初回に data-default-label として保持しておく
    // ============================================================
    const syncTabs = () => {
      const tabs = document.querySelectorAll('[data-filter-tabs] .filter-tab');

      tabs.forEach((tab) => {
        const target = tab.getAttribute('data-tab-target');
        const panel = document.querySelector('[data-panel="' + target + '"]');
        const labelEl = tab.querySelector('[data-text-label]');
        if (!panel || !labelEl) return;

        // 初回のみ、元の固定ラベル(カテゴリ名)を data-base-label として退避しておく
        // (data-default-label はこの後active時に上書きするため、復元用に別属性で保持する)
        if (!labelEl.hasAttribute('data-base-label')) {
          labelEl.setAttribute('data-base-label', labelEl.textContent.trim());
        }

        const activeLinks = panel.querySelectorAll('.active[data-filter-tag]');

        if (activeLinks.length > 0) {
          const titles = Array.prototype.map.call(activeLinks, (el) => el.textContent.trim()).filter(Boolean);

          tab.classList.add('active');
          // 表示テキストは変えず、data-default-label にだけ選択中タイトルを反映する
          labelEl.setAttribute('data-default-label', titles.join(', '));
        } else {
          tab.classList.remove('active');
          // 選択解除時は元のカテゴリ名に戻す
          labelEl.setAttribute('data-default-label', labelEl.getAttribute('data-base-label'));
        }
      });
    };


    document.addEventListener('click', function (e) {
      // data-filter-panel(タブ側パネル)の中にある .collection-filter だけを対象にする
      const link = e.target.closest('[data-filter-panel] .collection-filter[data-filter-tag]');
      if (!link) return;

      e.preventDefault();

      const clickedTag = link.dataset.filterTag;
      const isActive = link.dataset.filter === 'true';
      const clickedPrefix = clickedTag.split('_')[0];

      // 現在URLに乗っている tag= の一覧を取得
      const url = new URL(window.location.href.split('?')[0] + (link.getAttribute('href').includes('?') ? '?' + link.getAttribute('href').split('?')[1] : ''));
      let tags = url.searchParams.getAll('tag');

      // f_ と col_ は排他: 新たに追加されたタグが f_ か colde_ なら、逆側のプレフィックスを除去
      if (!isActive && (clickedPrefix === 'f' || clickedPrefix === 'colde')) {
        const otherPrefix = clickedPrefix === 'f' ? 'colde' : 'f';
        tags = tags.filter(t => t.split('_')[0] !== otherPrefix);
      }

      const newUrl = new URL(window.location.origin + window.location.pathname);
      tags.forEach(t => newUrl.searchParams.append('tag', t));

      window.location.href = newUrl.toString();
    });

    // ============================================================
    // 絞り込みモーダルの各行(refine-row)にも選択中タイトルを反映する
    // ============================================================
    const syncRefineRows = () => {
      const rows = document.querySelectorAll('.js-refine-nav[data-target]');

      rows.forEach((row) => {
        const target = row.getAttribute('data-target');

        if (target === 'sort') return; 
        const panel = document.querySelector('[data-panel="' + target + '"]');
        const valueEl = row.querySelector('[data-text-label]');
        if (!valueEl) return;

        if (!valueEl.hasAttribute('data-base-label')) {
          valueEl.setAttribute('data-base-label', valueEl.textContent.trim());
        }

        const activeLinks = panel ? panel.querySelectorAll('.active[data-filter-tag]') : [];
        let hasSelection = activeLinks.length > 0;
        let titles = Array.prototype.map.call(activeLinks, (el) => el.textContent.trim()).filter(Boolean);

        // ---- 追加: 「アイテム」行は、activeが無くても is-reactive があれば、そのラベルを使う ----
        // (item-type経由で対応カテゴリが分かっている場合、モーダル側が is-reactive を付けているので、
        //  それを上書きしないようにする)
        if (target === 'item' && !hasSelection) {
          const reactiveEls = document.querySelectorAll(
            '.refine-screen[data-screen="item"] .js-refine-select.is-reactive'
          );
          const reactiveTitles = Array.prototype.map.call(reactiveEls, (el) => el.textContent.trim()).filter(Boolean);
          if (reactiveTitles.length > 0) {
            titles = reactiveTitles;
            hasSelection = true;
          }
        }

        if (hasSelection) {
          row.classList.add('is-selected');
          valueEl.textContent = titles.join(', ');
        } else {
          row.classList.remove('is-selected');
          valueEl.textContent = valueEl.getAttribute('data-base-label');
        }
      });
    };

    // ============================================================
    // コレクションタイトルを「アイテム→対応機種→アイテムタイプ→カラー」の
    // 固定順で選択中ラベルを組み立てて表示する
    // ============================================================
    const TITLE_PANEL_ORDER = ['genre', 'color', 'item-type', 'model', 'item'];

    const renderCollectionTitle = () => {
      const titleEl = document.querySelector('[data-collection-title]');
      if (!titleEl) return;

      const labelEl = titleEl.querySelector('[data-text-label]');
      if (!labelEl) return;

      if (!labelEl.hasAttribute('data-base-label')) {
        labelEl.setAttribute('data-base-label', labelEl.textContent.trim());
      }

      const items = [];
      const seen = {};

      TITLE_PANEL_ORDER.forEach((panelName) => {
        const panel = document.querySelector('[data-panel="' + panelName + '"]');
        if (!panel) return;

        const activeLinks = panel.querySelectorAll('.active[data-filter-tag]');
        activeLinks.forEach((link) => {
          const tag = link.getAttribute('data-filter-tag');
          if (seen[tag]) return;
          seen[tag] = true;

          const label = link.textContent.trim();
          if (label) {
            items.push({ tag: tag, label: label, panel: panelName });
          }
        });
      });

      // 中身を一旦空にする
      labelEl.innerHTML = '';

      if (items.length) {
        items.forEach((item) => {
          const span = document.createElement('span');
          span.className = 'collection-title__item';
          span.setAttribute('data-filter-tag', item.tag);
          span.setAttribute('data-panel', item.panel);
          span.textContent = item.label;
          labelEl.appendChild(span);
        });
      } else {
        labelEl.textContent = labelEl.getAttribute('data-base-label');
      }
    };

    const init = () => {
      const currentTags = getCurrentTagsFromUrl();
      applyActiveStates(currentTags);
      syncPanels();
      syncTabs();
      syncRefineRows();
      renderCollectionTitle();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  (() => {
    'use strict';

    const initFilterWrapSticky = () => {
      const wrapEl = document.querySelector('[data-filter-wrap]');
      const placeholderEl = document.querySelector('[data-filter-wrap-placeholder]');
      const footerEl = document.querySelector('#shopify-section-footer'); // 追加
      if (!wrapEl || !placeholderEl) return;

      const getHeaderHeight = () => {
        const header = document.querySelector('[data-header-section]');
        const announcement = document.querySelector('#announcement-bar');
        const h1 = header ? header.getBoundingClientRect().height : 0;
        const h2 = announcement ? announcement.getBoundingClientRect().height : 0;
        return h1 + h2 + 20; // 20px 増し
      };

      let isSticky = false;

      const applySticky = () => {
        const headerH = getHeaderHeight();
        placeholderEl.style.height = wrapEl.offsetHeight + 'px';
        placeholderEl.classList.add('is-active');
        wrapEl.classList.add('is-sticky');
        wrapEl.style.top = headerH + 'px';
        isSticky = true;
      };

      const removeSticky = () => {
        wrapEl.classList.remove('is-sticky', 'is-hidden'); // 隠しクラスも除去
        wrapEl.style.top = '';
        placeholderEl.classList.remove('is-active');
        placeholderEl.style.height = '';
        isSticky = false;
      };

      const onScroll = () => {
        const headerH = getHeaderHeight();

        if (!isSticky) {
          const wrapTop = wrapEl.getBoundingClientRect().top;
          if (wrapTop <= headerH) applySticky();
        } else {
          const placeholderTop = placeholderEl.getBoundingClientRect().top;
          if (placeholderTop > headerH) {
            removeSticky();
          } else {
            wrapEl.style.top = headerH + 'px';
          }
        }

        // フッター到達時に隠す
        if (isSticky && footerEl) {
          const footerTop = footerEl.getBoundingClientRect().top; // ビューポート基準のフッター上端
          const wrapHeight = wrapEl.offsetHeight;
          const shouldHide = footerTop <= headerH + wrapHeight;
          wrapEl.classList.toggle('is-hidden', shouldHide);
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      // 初期状態でも判定
      onScroll();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFilterWrapSticky);
    } else {
      initFilterWrapSticky();
    }
  })();
  
  
  (() => {
  const tabsWrapper = document.querySelector('[data-filter-tabs]');
  const overlay = document.querySelector('[data-filter-panel-overlay]');
  if (!tabsWrapper || !overlay) return;

  const tabs = tabsWrapper.querySelectorAll('.filter-tab');
  const panels = overlay.querySelectorAll('[data-panel]');
  const closeBtn = overlay.querySelector('[data-filter-panel-close]');

  const openPanel = (target) => {
    panels.forEach(p => p.hidden = p.dataset.panel !== target);
    tabs.forEach(t => t.classList.toggle('toggleActive', t.dataset.tabTarget === target));
    overlay.hidden = false;
  };

  const closePanel = () => {
    overlay.hidden = true;
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', () => openPanel(tab.dataset.tabTarget));
  });

  closeBtn?.addEventListener('click', closePanel);

  // 枠の外側(オーバーレイ背景)クリックで閉じる
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      closePanel();
    }
  });

  // タグ選択時に閉じる(data-filter-tagを持つ実際の絞り込みリンクのみ)
  overlay.addEventListener('click', (e) => {
    const link = e.target.closest('a[data-filter-tag]');
    if (link) {
      closePanel();
      // ページ遷移自体はhref通りに発生するので、ここではclosePanelのみでOK
    }
  });

  // アコーディオン開閉(data-filter-parent)
  overlay.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-filter-parent]');
    if (!btn) return;

    const group = btn.closest('[data-filter-group]');
    if (!group) return;

    const children = group.querySelector('.filter-children');
    if (!children) return;

    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    const panel = btn.closest('[data-panel]');

    panel?.querySelectorAll('[data-filter-group]').forEach((g) => {
      const c = g.querySelector('.filter-children');
      const b = g.querySelector('[data-filter-parent]');
      if (c) c.hidden = true;
      if (b) b.setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      children.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }
  });
})();



/**
 * collection-filter-links.js
 * ------------------------------------------------------------
 * Liquidの current_tags は、クエリパラメータ形式のURL
 * (/collections/all?tag=xxx&tag=yyy) を認識できない
 * (Shopifyはパス形式のタグしか current_tags に反映しないため)。
 *
 * そのため、各フィルターパネルのリンクの href / active状態を、
 * このスクリプトが window.location.search から実際の状態を読み取り、
 * ページ読み込み後に正しく再計算・上書きする。
 *
 * Liquid側は「タグの一覧・ラベル・構造」を出力するだけでよく、
 * 「今何が選ばれていて、次にどこへ飛ぶか」はすべてここで決まる。
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  const { H1_CATEGORY_MAP, ITEM_CATEGORY_MAP } = window.CATEGORY_MAPS;
  const ITEM_TAG_VALUES = Object.keys(ITEM_CATEGORY_MAP);

  // ============================================================
  // 2. パネルごとの「除外ルール」
  //    href生成時、このルールに該当するタグは維持せず除外する
  //    (=このパネルで新しく選ぶタグと同じ種類のものだけ入れ替える)
  // ============================================================
  const PANEL_EXCLUDE_RULES = {
    // 「アイテム」を選ぶ際は、代表タグだけでなく h1_ タグ全般を必ずリセットする
    // (アイテムタイプ経由で個別のh1_タグが選ばれていても、アイテム切り替え時は必ず1つにする)
    item: (t) => ITEM_TAG_VALUES.indexOf(t) !== -1 || t.indexOf('h1_') === 0,
    model: (t) => t.indexOf('mo_') === 0 || t.indexOf('watchband') === 0 || t.indexOf('earphonecase') === 0 || t.indexOf('pccase') === 0,
    'item-type': (t) => t.indexOf('h1_') === 0 || t.indexOf('m_') === 0,
    color: (t) => t.indexOf('cl_') === 0,
    genre: (t) => t.indexOf('col_') === 0 || t.indexOf('colde_') === 0 || t.indexOf('pl_') === 0 || t.indexOf('f_') === 0,
  };

  // ============================================================
  // 3. 現在のURLから、実際に有効なタグ一覧を取得する
  // ============================================================
  function getCurrentTags() {
    const params = new URLSearchParams(window.location.search || '');
    const tags = [];
    params.getAll('tag').forEach(function (t) {
      if (t) tags.push(t.toLowerCase());
    });
    return tags;
  }

  function getLocalePrefix() {
    const match = window.location.pathname.match(/^\/([a-z]{2}(-[a-z]{2})?)\//i);
    if (!match) return '';
    return '/' + match[1];
  }

  function getCollectionBasePath() {
    // 現在のパスから "/collections/{handle}" 部分だけを取り出す
    // (クエリパラメータ形式なので、handleの後ろに階層は無い前提)
    const path = window.location.pathname;
    const marker = '/collections/';
    if (!path.includes(marker)) return path;

    const after = path.split(marker)[1] || '';
    const handle = after.split('/')[0];
    return getLocalePrefix() + marker + handle;
  }

  // ============================================================
  // 4. 1つのリンクについて、正しい href / active状態を再計算する
  // ============================================================
  function rebuildLink(link, currentTags, excludeRule) {
    const targetTag = (link.getAttribute('data-filter-tag') || '').toLowerCase();
    if (!targetTag) return;

    const isActive = currentTags.indexOf(targetTag) !== -1;

    const kept = currentTags.filter(function (t) {
      return !excludeRule(t);
    });

    if (!isActive) {
      kept.push(targetTag);
    }
    // isActive の場合は kept に targetTag を含めない(=クリックで解除)

    const basePath = getCollectionBasePath();
    let href = basePath;
    if (kept.length > 0) {
      href += '?' + kept.map(function (t) {
        return 'tag=' + encodeURIComponent(t);
      }).join('&');
    }

    link.setAttribute('href', href);
    link.classList.toggle('active', isActive);
    if (link.hasAttribute('data-filter')) {
      link.setAttribute('data-filter', isActive ? 'true' : 'false');
    }
  }

  // ============================================================
  // 5. パネルごとに、中の全リンクを再計算する
  // ============================================================
  function rebuildPanel(panelEl, currentTags) {
    const panelName = panelEl.getAttribute('data-panel');
    const excludeRule = PANEL_EXCLUDE_RULES[panelName];
    if (!excludeRule) return;

    panelEl.querySelectorAll('[data-filter-tag]').forEach(function (link) {
      rebuildLink(link, currentTags, excludeRule);
    });

    // 親カテゴリ(tag-nav__group)の is-active も再計算する
    // (トグル開閉は廃止したので、is-active はスタイリング用のフックとしてのみ使う)
    panelEl.querySelectorAll('[data-parent-category]').forEach(function (group) {
      const hasActiveChild = !!group.querySelector('[data-filter-tag].active');
      group.classList.toggle('is-active', hasActiveChild);
    });
  }

  // ============================================================
  // 6. 「アイテム」で何も選ばれていなくても、アクティブな h1_ タグから
  //    該当カテゴリを推測して、アイテムパネル側もハイライトする
  // ============================================================
  function getActiveItemCategory(currentTags) {
    // すでに「アイテム」の代表タグそのものがアクティブならそれを優先
    const directItemTag = currentTags.find(function (t) {
      return ITEM_TAG_VALUES.indexOf(t) !== -1;
    });

    if (directItemTag) {
      return ITEM_CATEGORY_MAP[directItemTag];
    }

    // 代表タグが無くても、アクティブな h1_ タグからカテゴリを推測する
    const activeH1 = currentTags.find(function (t) {
      return Object.prototype.hasOwnProperty.call(H1_CATEGORY_MAP, t);
    });

    return activeH1 ? H1_CATEGORY_MAP[activeH1] : null;
  }
  function syncItemPanelWithActiveH1(currentTags) {
    const itemPanel = document.querySelector('[data-panel="item"]');
    if (!itemPanel) return;

    const activeCategory = getActiveItemCategory(currentTags);
    let reactiveTitle = '';

    itemPanel.querySelectorAll('[data-filter-tag]').forEach(function (link) {
      const tag = (link.getAttribute('data-filter-tag') || '').toLowerCase();
      const category = ITEM_CATEGORY_MAP[tag];
      const shouldHighlight = !!activeCategory && category === activeCategory;
      link.classList.toggle('is-reactive', shouldHighlight);
      if (shouldHighlight) {
        reactiveTitle = link.textContent.trim();
      }
    });

    // ---- 追加: 対応するタブボタン自体にも is-reactive を反映する ----
    const itemTab = document.querySelector('.filter-tab[data-tab-target="item"]');
    if (!itemTab) return;

    const hasOwnActive = !!itemPanel.querySelector('[data-filter-tag].active');

    // 本人が明示的にitemを選んでいる(active)場合は、それを優先してis-reactiveは付けない
    if (hasOwnActive) {
      itemTab.classList.remove('is-reactive');
      return;
    }

    itemTab.classList.toggle('is-reactive', !!reactiveTitle);

    const labelEl = itemTab.querySelector('[data-text-label]');
    if (labelEl) {
      if (!labelEl.hasAttribute('data-base-label')) {
        labelEl.setAttribute('data-base-label', labelEl.textContent.trim());
      }
      if (reactiveTitle) {
        labelEl.setAttribute('data-default-label', reactiveTitle);
      } else {
        labelEl.setAttribute('data-default-label', labelEl.getAttribute('data-base-label'));
      }
    }
  }
  // ============================================================
  // 7. 「アイテム」でカテゴリが選ばれている間は、「アイテムタイプ」
  //    パネルもそのカテゴリのグループだけを表示する
  // ============================================================
  function filterItemTypeByActiveCategory(currentTags) {
    const panel = document.querySelector('[data-panel="item-type"]');
    if (!panel) return;

    const activeCategory = getActiveItemCategory(currentTags);

    panel.querySelectorAll('[data-parent-category]').forEach(function (group) {
      const label = group.getAttribute('data-category-label');
      const matches = !activeCategory || label === activeCategory;
      group.hidden = !matches;
    });
  }

  // ============================================================
  // 実行
  // ============================================================
  function init() {
    const currentTags = getCurrentTags();

    document.querySelectorAll('[data-panel]').forEach(function (panelEl) {
      rebuildPanel(panelEl, currentTags);
    });

    syncItemPanelWithActiveH1(currentTags);
    filterItemTypeByActiveCategory(currentTags);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();




